import api from '~/services/locality/locality';

export default {
  async actionGetAllCountries() {
    try {
      const result = await api.getAllCountries();
      return result;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async actionGetStatesByCountry(root, { countryCode, query }) {
    try {
      const result = await api.getStatesByCountry(countryCode, query);
      return result;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async actionGetCityByCountryAndByState(root, { countryCode, stateCode, query }) {
    try {
      const result = await api.getCityByCountryAndByState(countryCode, stateCode, query);
      return result;
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async actionGetLocalities(root, query) {
    try {
      const result = await api.getLocalities(query);
      return result;
    } catch (err) {
      return Promise.reject(err);
    }
  }

};
